<template>
  <v-btn @click.stop="onCopy()" depressed :height="height">
    <svg
      v-if="copy"
      :key="'copy' + key"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="20px"
      height="20px"
      viewBox="0 0 45 35"
      xml:space="preserve"
    >
      <polyline
        fill="none"
        points="3,21 14,35 41,1 "
        stroke="currentColor"
        stroke-width="5"
        stroke-dasharray="200"
        stroke-dashoffset="200"
        stroke-linecap="round"
      />
    </svg>
    <svg
      v-else
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.625 0.125H3.20312C3.12578 0.125 3.0625 0.188281 3.0625 0.265625V1.25C3.0625 1.32734 3.12578 1.39062 3.20312 1.39062H11.9219V13.4844C11.9219 13.5617 11.9852 13.625 12.0625 13.625H13.0469C13.1242 13.625 13.1875 13.5617 13.1875 13.4844V0.6875C13.1875 0.376367 12.9361 0.125 12.625 0.125ZM10.375 2.375H1.375C1.06387 2.375 0.8125 2.62637 0.8125 2.9375V12.2662C0.8125 12.4156 0.872266 12.558 0.977734 12.6635L4.02402 15.7098C4.0627 15.7484 4.10664 15.7801 4.1541 15.8064V15.8398H4.22793C4.28945 15.8627 4.35449 15.875 4.42129 15.875H10.375C10.6861 15.875 10.9375 15.6236 10.9375 15.3125V2.9375C10.9375 2.62637 10.6861 2.375 10.375 2.375ZM4.71484 14.75H4.71133L2.07812 12.1168V12.1133H4.71484V14.75Z"
        fill="#F2F2F2"
      />
    </svg>
  </v-btn>
</template>

<script>
export default {
  name: 'ButtonCopy',
  props: {
    text: {
      type: String,
      default: '',
    },
    height: {
      type: [Number, String],
      default: '100%',
    },
  },
  data: () => ({
    copy: false,
    key: 0,
  }),
  watch: {
    copy() {
      if (this.copy === true) {
        setTimeout(() => {
          this.copy = false
        }, 1500)
      }
    },
  },
  methods: {
    onCopy() {
      try {
        navigator.clipboard.writeText(this.text)
        this.key++
        this.copy = true
      } catch (e) {
        throw e
      }
    },
  },
}
</script>

<style scoped lang="scss">
.v-btn {
  margin-left: 20px;
  min-width: 56px !important;
  //height: 100% !important;
  max-height: 48px !important;
  background-color: #277faf !important;
  color: white;
  border-radius: 10px;
}

polyline {
  animation: anim;
  animation-duration: 2s;
  animation-delay: 0.3s;
  animation-fill-mode: forwards;
  animation-timing-function: ease-out;

  -moz-animation: anim;
  -moz-animation-duration: 2s;
  -moz-animation-delay: 0.3s;
  -moz-animation-fill-mode: forwards;
  -moz-animation-timing-function: ease-out;
}

@keyframes anim {
  0% {
    stroke-dashoffset: 200;
  }
  50% {
    stroke-dashoffset: 50;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
</style>
